var map = {
	"./logo_arab.svg": "96e1",
	"./logo_ch.svg": "94f7",
	"./logo_en.svg": "d1ea",
	"./logo_es.svg": "25e8",
	"./logo_fra.svg": "77ec",
	"./logo_por.svg": "f9b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d47a";